import {
    cleanCommonParams,
} from './common';

const mapCollateralPriceParams = (
    isCreate,
    {
        slug,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            collateral_price: {
                ...cleanCommonParams(params),
            },
        });
    });
};

export { mapCollateralPriceParams };
